import { bindActionCreators } from 'redux';
import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';
import SiteConf from 'models/SiteConf';
import Me from 'models/Me';
import Event from 'models/Event';
import BootstrapData from 'models/BootstrapData';
import Global from 'models/Global';
import Analytics from 'models/Analytics';
import config from 'config';
import bootstrap from 'bootstrap';
import NavigationView from './views/NavigationView';
import AuthView from './views/AuthView';
import FooterView from 'web-common/scripts/views/FooterView';
import SocialShareView from './views/reactViews/SocialShareView';
import { renderReact } from './utils/reactRoot';
import React from 'react';
import FeatureToggleUtils from 'FeatureToggleUtils';

import {
    fetchAllPersons,
    updateMe,
    validateLinkedInToken,
    updateExternalIds
} from './actions/CommunityActions';
import { getAccessToken } from './AuthToken';

export default (dispatch, webSocket) => {
    const actions = bindActionCreators({
        fetchAllPersons,
        updateMe,
        updateExternalIds,
        validateLinkedInToken
    }, dispatch);

    const noJoin = /\/agenda\b/.test(document.location.pathname);

    var event = new Event(BootstrapData('bootstrap-data-event'));
    var me = new Me(_.extend(BootstrapData('bootstrap-data-me'), {noJoin, getToken: getAccessToken}), {parse: true});
    var siteConf = new SiteConf(BootstrapData('bootstrap-data-siteConf'));
    var disableInteractions = BootstrapData('bootstrap-data-disableInteractionsObject').disableInteractionsObject;
    var isWidget = BootstrapData('bootstrap-data-isWidgetObject').isWidget;
    var nextUrl = BootstrapData('bootstrap-data-nextUrlObject').nextUrl;
    var isVerified = BootstrapData('bootstrap-data-isVerifiedObject').isVerified;
    var verifiedUserEmail = BootstrapData('bootstrap-data-isVerifiedObject').verifiedUserEmail;
    var verificationExpired = BootstrapData('bootstrap-data-isVerifiedObject').verificationExpired;
    var socialShareSettings = BootstrapData('bootstrap-data-socialShare');
    const isCookieConsentEnabled = BootstrapData('bootstrap-data-isCookieConsentEnabled');
    Global.set('eventId', event.id);
    Global.set('isWidget', isWidget);
    Global.set('webSocket', webSocket);
    Global.set('me', me);
    Global.set('event', event);
    Global.set('accountId', event.get('account-id'));
    Global.set('uniqueName', event.get('unique-name'));
    Global.set('id', event.get('id'));
    Global.set('socialShare', socialShareSettings);

    Global.set('websiteType', event.get('websiteType'));
    Global.set('whitelabelPath', event.get('whitelabelPath'));
    Global.set('whitelabelWidgetEnabled', event.get('whitelabelWidgetEnabled'));
    Global.set('onlyEventDomain', event.get('onlyEventDomain'));
    Global.set('internalWebsiteBaseUrl', event.getInternalWebsiteBaseUrl());

    if (isVerified) {
        Global.get('me').set('isVerified', true);
    }
    verifiedUserEmail && Global.set('verifiedUserEmail', verifiedUserEmail);
    verificationExpired && Global.set('verificationExpired', verificationExpired);

    // analytics section
    var analytics = new Analytics();

    const { primaryEmail, firstName, lastName } = me.toJSON();
    const { id: eventId } = event.toJSON();
    const identifyPayload = {
        email: primaryEmail,
        displayName: `${firstName} ${lastName}`,
        eventId,
    };

    analytics.loadClarity();

    if (primaryEmail) {
        analytics.setClarityIdentity(identifyPayload);
    }

    function listenToMessages() {
        window.addEventListener('message', receivedMessage, false);
    }

    function receivedMessage(e) {
        var json;
        if (e.origin == config.dashboardUrl) {
            if (e.data == 'reload') {
                window.location.reload(false);
                return;
            }
            try {
                json = JSON.parse(e.data);
            } catch (e) {
                json = null;
            }
            json && siteConf.set(json);
        }
    }

    // ////// End whitelabel ////////

    function initTopNavigation() {
        new NavigationView({
            el: $('header.navigation-header'),
            model: siteConf,
            me: me,
            event: event,
            disableInteractions: disableInteractions
        }).render();
    }

    function initFooter() {
        new FooterView({
            el: document.getElementsByTagName('footer'),
            model: siteConf,
            event: event,
            disableInteractions: disableInteractions,
            isCookieConsentEnabled
        }).render();
    }

    function initAuthView() {
        const isPeopleV2Community = event?.get('features')?.communityVersion === 'PEOPLE_V2';
        if ((me.isNew() || !me.get('isJoined')) && !isPeopleV2Community) {
            new AuthView({
                el: $('.auth-view'),
                me: me,
                event: event
            });
        }

    }

    function socialShareHideAndRemove() {
        if (nextUrl) {
            window.location.replace(nextUrl);
            return;
        }
        if (Global.get('page') == 'home') {
            window.location.reload();
        }
        const socialShareElem = document.getElementById('community-social-share');
        socialShareElem && socialShareElem.remove();
    }

    function joinedStateChanged() {
        if (!me.get('isJoined')) {
            return;
        }
        if (nextUrl) {
            window.location.replace(nextUrl);
            return;
        }

        const communitySettings = !_.isEmpty(socialShareSettings) && socialShareSettings.find(settings => settings.sectionType === 'community');
        if (me.get('joinedNow')) {
            if (communitySettings) {
                const atLeastOneNetworkEnabled = communitySettings.socialNetworks.some(socialNetwork => socialNetwork.enabled);
                if (communitySettings.active && atLeastOneNetworkEnabled) {
                    const profileImg = me && me.get('photoSet') && me.get('photoSet').medium;
                    renderReact(
                        document.getElementById('community-social-share'),
                        <SocialShareView
                            communitySettings={communitySettings}
                            profileImg={profileImg}
                            eventUrl={event.get('homepage-url')}
                            onHide={socialShareHideAndRemove.bind(this)}
                        />
                    );
                }
            }
        }

        _.delay(() => {
            actions.updateMe(me.toJSON());
            actions.validateLinkedInToken();
            actions.fetchAllPersons({
                eventId: event.get('id')
            });
        }, 1500);
    }

    me.on('change:isJoined', joinedStateChanged);
    me.on('change:joinedNow', joinedStateChanged);

    function setScrollingEnabled(enabled) {
        $('body').toggleClass('no-scrolling', !enabled);
    }

    Backbone.on('set-scrolling', setScrollingEnabled);


    function linkedInIdnUpdated(id) {
        id && actions.updateExternalIds('linkedInId', id);
    }

    $('body').on('mouseup', 'button, .btn', function() {
        this.blur();
    });

    Backbone.on('linkedin-id-updated', linkedInIdnUpdated);
    initTopNavigation();
    initFooter();
    initAuthView();
    listenToMessages();
};
